import React, { useContext, useMemo } from 'react';
import Tags from '@wix/da-shared-react/pkg/Tags';
import { MobileContext } from '@wix/da-shared-react/pkg/Context/MobileContext';
import { Pages } from '../../../../constants';
import { TagStrip } from '../../../../types/api';
import StripWrapper from '../StripWrapper';

export interface Props {
  strip: TagStrip;
  page?: Pages;
  className?: string;
}

const TagsStrip: React.FC<Props> = ({ strip, page, className }) => {
  const isMobile = useContext(MobileContext);

  const tags = useMemo(
    () =>
      strip.tags.map(stripTag => ({ name: stripTag.tag, url: stripTag.url })),
    [strip.tags]
  );

  return (
    <StripWrapper strip={strip} page={page!} className={className}>
      <Tags tags={tags} isFoldable={!isMobile} />
    </StripWrapper>
  );
};
TagsStrip.displayName = 'TagsStrip';

export default TagsStrip;
